import { render, staticRenderFns } from "./TopDevelopersReport.vue?vue&type=template&id=36e9c0bc&"
import script from "./TopDevelopersReport.vue?vue&type=script&lang=js&"
export * from "./TopDevelopersReport.vue?vue&type=script&lang=js&"
import style0 from "./TopDevelopersReport.vue?vue&type=style&index=0&id=36e9c0bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports